import React from "react";
import clsx from "clsx";
import { Box, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import styles from "./PanelStyles";

export const Panel = props => {
  const { classes, replacePanelClass, modifyPanelClass, renderFooter, overrideContentStyle } = props;
  let panelContentStyle = overrideContentStyle || classes.panelContent

  const applyPanelClass = () => {
    let classesApplied = clsx(classes.panel, classes.panelTop);
    if (replacePanelClass) {
      classesApplied = clsx(replacePanelClass, classes.panelTop);
    } else if (modifyPanelClass) {
      classesApplied = clsx(classes.panel, modifyPanelClass, classes.panelTop);
    }
    return classesApplied;
  };

  return (
    <Paper className={applyPanelClass()}>
      <Box className={classes.panelTitle}>
        <h3>{props.title}</h3>
      </Box>
      <Box pt={2} pl={2} pr={2} className={panelContentStyle}>
        {props.children}
      </Box>
      <Box pl={2} pr={2} className={classes.stickyFooter}>
        {renderFooter && renderFooter()}
      </Box>
    </Paper>
  );
};

export default withStyles(styles)(Panel);
